import { describeFields, FieldWidget } from '../common/fields';
import { LessonEnrolmentSchema } from './schemas';

export const LESSON_ENROLMENT_FIELDS = describeFields(LessonEnrolmentSchema, {
  student: {},
  course: {},
  present: { widget: FieldWidget.Text },
  homework: {},
  enrolmentMethod: {},
  attendanceType: {},
  startDatetime: { widget: FieldWidget.DateTime },
  attendanceNotified: { widget: FieldWidget.Text },
  separatelyBilled: { widget: FieldWidget.Text },
  stream: {},
});
